import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  sabbaticalLeaveRequests: [],
  isManangerCheck: null,
  sabbaticalLeaveApproval: [],
  sabbaticalLeaveRequest: {},
  commonReasons: [],
  dataCommons: [],
  reasons: [],
  approveEmployees: [],
  employeeSabbaticalInfo: [],
  employeeSabbaticalRequest: {},
  timeWeekend: 0,
  listSabbaticalRequest: [],
  expireSabbatical: [],
  expireSabbaticalDashboard: [],
  expireSabbaticalLog: [],
  expireSabbaticalLeave: 0,
  totalSabbticalRequest: {}
};

// getters
export const getters = {
  sabbaticalLeaveRequests: state => state.sabbaticalLeaveRequests,
  isManangerCheck: state => state.isManangerCheck,
  sabbaticalLeaveApproval: state => state.sabbaticalLeaveApproval,
  sabbaticalLeaveRequest: state => state.sabbaticalLeaveRequest,
  commonReasons: state => state.commonReasons,
  pagination: state => state.pagination,
  dataCommons: state => state.dataCommons,
  reasons: state => state.reasons,
  approveEmployees: state => state.approveEmployees,
  employeeSabbaticalInfo: state => state.employeeSabbaticalInfo,
  employeeSabbaticalRequest: state => state.employeeSabbaticalRequest,
  timeWeekend: state => state.timeWeekend,
  listSabbaticalRequest: state => state.listSabbaticalRequest,
  expireSabbatical: state => state.expireSabbatical,
  expireSabbaticalDashboard: state => state.expireSabbaticalDashboard,
  expireSabbaticalLog: state => state.expireSabbaticalLog,
  expireSabbaticalLeave: state => state.expireSabbaticalLeave,
  totalSabbticalRequest: state => state.totalSabbticalRequest
};

// mutations
export const mutations = {
  [types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_REQUEST](
    state,
    data
  ) {
    state.isManangerCheck = data.ruleJob;
    state.sabbaticalLeaveRequests = data.sabbaticalLeaveRequests;
    state.pagination.from = data.sabbaticalLeaveRequests.from;
    state.pagination.to = data.sabbaticalLeaveRequests.to;
    state.pagination.totalPage = data.sabbaticalLeaveRequests.last_page;
    state.pagination.path = data.sabbaticalLeaveRequests.path;
    state.pagination.currentPage = data.sabbaticalLeaveRequests.current_page;
    state.pagination.totalRecord = data.sabbaticalLeaveRequests.total;
    state.pagination.perPage = data.sabbaticalLeaveRequests.per_page;
    state.totalSabbticalRequest = data.countSabbaticalRequest;
  },
  [types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_APPROVAL](
    state,
    data
  ) {
    state.sabbaticalLeaveApproval = data.sabbaticalLeaveRequests;
    state.pagination.from = data.sabbaticalLeaveRequests.from;
    state.pagination.to = data.sabbaticalLeaveRequests.to;
    state.pagination.totalPage = data.sabbaticalLeaveRequests.last_page;
    state.pagination.path = data.sabbaticalLeaveRequests.path;
    state.pagination.currentPage = data.sabbaticalLeaveRequests.current_page;
    state.pagination.totalRecord = data.sabbaticalLeaveRequests.total;
    state.pagination.perPage = data.sabbaticalLeaveRequests.per_page;
    state.totalSabbticalRequest = data.countSabbaticalRequest;
  },
  [types.SABBATICAL_LEAVE_REQUEST.DETAIL_SABBATICAL_LEAVE_REQUEST](
    state,
    sabbaticalLeaveRequest
  ) {
    state.sabbaticalLeaveRequest = sabbaticalLeaveRequest;
  },
  [types.SABBATICAL_LEAVE_REQUEST.LIST_SABBATICAL_REQUEST_ALL_APPROVAL](
    state,
    listSabbaticalRequest
  ) {
    state.listSabbaticalRequest = listSabbaticalRequest;
  },
  [types.SABBATICAL_LEAVE_REQUEST.COMMON_REASONS](
    state,
    sabbaticalLeaveRequests
  ) {
    state.commonReasons = sabbaticalLeaveRequests;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_DATA_COMMON](state, data) {
    state.dataCommons = data.employee;
    state.reasons = data.reasons;
    state.approveEmployees = data.approveEmployees;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_INFO_SABBATICAL](state, data) {
    state.employeeSabbaticalInfo = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.SHOW_SABBATICAL_REQUEST_APPROVAL](
    state,
    data
  ) {
    state.employeeSabbaticalRequest = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_CALCULATE_DAY_LEAVE](state, data) {
    if (data) {
      state.timeWeekend = data;
    } else {
      state.timeWeekend = 0;
    }
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL](state, data) {
    state.expireSabbatical = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_DASHBOARD_EXPIRE_SABBATICAL](
    state,
    data
  ) {
    state.expireSabbaticalDashboard = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LOG](state, data) {
    state.expireSabbaticalLog = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LEAVE](state, data) {
    state.expireSabbaticalLeave = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.CLEAR_DATA](state) {
    state.expireSabbatical = [];
    state.expireSabbaticalLog = [];
  }
};

// actions
export const actions = {
  async listSabbaticalLeaveRequests({ commit }, payload) {
    const response = await axios.get(api.LIST_SABBATICAL_LEAVE_REQUEST, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        approve_person: payload.approvePerson,
        status: payload.status,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy
      }
    });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_REQUEST,
      response.data
    );
  },

  async listSabbaticalLeaveApproval({ commit }, payload) {
    const response = await axios.get(api.LIST_SABBATICAL_LEAVE_APPROVAL, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        reason: payload.reason,
        status: payload.status,
        approveStatus: payload.approveStatus,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy
      }
    });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_APPROVAL,
      response.data
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.LIST_SABBATICAL_REQUEST_ALL_APPROVAL,
      response.data.listSabbaticalRequest
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.COMMON_REASONS,
      response.data.commonReasons
    );
  },

  async detailSabbaticalLeaveRequest({ commit }, sabbaticalLeaveRequestId) {
    const response = await axios.get(
      api.SHOW_SABBATICAL_LEAVE_REQUEST + "/" + sabbaticalLeaveRequestId
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.DETAIL_SABBATICAL_LEAVE_REQUEST,
      response.data
    );
  },

  // eslint-disable-next-line
  deleteSabbaticalLeaveRequest({ commit }, sabbaticalLeaveRequestId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          api.DELETE_SABBATICAL_LEAVE_REQUEST + "/" + sabbaticalLeaveRequestId
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async getDataCommons({ commit }) {
    const response = await axios.get(api.GET_DATA_COMMON);
    commit(types.SABBATICAL_LEAVE_REQUEST.GET_DATA_COMMON, response);
  },

  // eslint-disable-next-line
  async createSabbaticalRequest({ commit }, params) {
    await axios.post(api.CREATE_SABBATICAL, params);
  },

  async getInfoSabbatical({ commit }, params) {
    let url = `${api.GET_INFO_SABBATICAL}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(types.SABBATICAL_LEAVE_REQUEST.GET_INFO_SABBATICAL, response.data);
    }
  },

  // eslint-disable-next-line
  async updateSabbaticalRequest({ commit }, params) {
    let url = `${api.UPDATE_SABBATICAL}/${params.sabbatical_request_id}`;
    await axios.post(url, params);
  },

  async showEmployeeSabbaticalRequest({ commit }, sabbaticalRequestId) {
    const response = await axios
      .get(api.SHOW_SABBATICAL_REQUEST_APPROVAL + "/" + sabbaticalRequestId)
      .catch(e => console.log(e));
    if (response) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.SHOW_SABBATICAL_REQUEST_APPROVAL,
        response.data
      );
    }
  },

  // eslint-disable-next-line
  async approvalSabbatical({ commit }, params) {
    let url = `${api.APPROVE_SABBATICAL}/${params.id}`;
    await axios.post(url, params.data);
  },

  async getCalculateDayLeave({ commit }, payload) {
    let url = `${api.GET_CALCULATE_DAY_LEAVE}`;
    const response = await axios.get(url, {
      params: {
        end_time: payload.end_time,
        start_time: payload.start_time,
        start_date: payload.start_date,
        end_date: payload.end_date
      }
    });
    if (response.status == 200) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.GET_CALCULATE_DAY_LEAVE,
        response.data
      );
    }
  },

  // eslint-disable-next-line
  async approvalListSabbatical({ commit }, params) {
    let url = `${api.APPROVE_LIST_SABBATICAL}`;
    await axios.post(url, params);
  },

  async getDashboardExpireSabbatical({ commit }) {
    let url = `${api.SABBATICAL_DASHBOARD_DAYS_OFF}`;
    const response = await axios.get(url);
    if (response.status == 200) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.GET_DASHBOARD_EXPIRE_SABBATICAL,
        response.data
      );
    }
  },

  async getExpireSabbatical({ commit }) {
    let url = `${api.SABBATICAL_DAYS_OFF}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL,
        response.data
      );
    }
  },
  async clearData({ commit }) {
    commit(types.SABBATICAL_LEAVE_REQUEST.CLEAR_DATA);
  },
  //sabbatical-log
  async getExpireSabbaticalLog({ commit }) {
    let url = `${api.SABBATICAL_LOG}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LOG,
      response.data
    );
  },
  async getExpireSabbaticalLeave({ commit }) {
    let url = `${api.SABBATICAL_LEAVE}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LEAVE,
      response
    );
  }
};
